import { platformDomains } from "./domain.constant";

export const MOLE_COMPANY_CODE = "mole";

export const MOLE_DOMAINS = [...platformDomains, "proje", "proje-test"];

/** Mol-e ana sözleşmeleri — backend ContractTypeEnum ile eşleşir */
export const CONTRACT_TYPE = {
  KVKK: 0,
  MEMBERSHIP: 10,
  COOKIE: 20,
};

export const CONTRACT_TYPE_ORDER = [
  CONTRACT_TYPE.KVKK,
  CONTRACT_TYPE.MEMBERSHIP,
  CONTRACT_TYPE.COOKIE,
];

/** Whitelabel ek sözleşme tipleri (100+) */
export const WHITELABEL_CONTRACT_TYPE = {
  CAMPAIGN: 100,
  PRIVACY_ADDENDUM: 110,
  PARTNER: 120,
  DATA_PROCESSING: 130,
  CONTEST: 140,
  COMMUNICATION: 150,
  LOCATION: 160,
  SPECIAL_TERMS: 170,
  RECYCLING: 180,
  CORPORATE: 190,
  OTHER: 200,
};

export const WHITELABEL_CONTRACT_TYPE_ORDER = Object.values(
  WHITELABEL_CONTRACT_TYPE,
);

export const SIGNUP_CONTRACT_APPROVALS_KEY = "mole:signup-contract-approvals";

export const CONTRACT_LINK_CLASS_NAME =
  "underline font-medium text-kostebek-600";

export const contractTypeList = [
  {
    value: CONTRACT_TYPE.KVKK,
    colors: "bg-violet-500 text-violet-50",
  },
  {
    value: CONTRACT_TYPE.MEMBERSHIP,
    colors: "bg-blue-500 text-blue-50",
  },
  {
    value: CONTRACT_TYPE.COOKIE,
    colors: "bg-amber-500 text-amber-50",
  },
  ...WHITELABEL_CONTRACT_TYPE_ORDER.map((value) => ({
    value,
    colors: "bg-teal-500 text-teal-50",
  })),
];

export const isCoreContractType = (type) =>
  CONTRACT_TYPE_ORDER.includes(Number(type));

export const isWhitelabelContractType = (type) =>
  WHITELABEL_CONTRACT_TYPE_ORDER.includes(Number(type));

export const getContractTypeMeta = (type) =>
  contractTypeList.find((item) => item.value === type);

export const getContractTypeLabel = (type, t) => {
  const numericType = Number(type);

  if (isCoreContractType(numericType)) {
    return t(`contracts.types.${numericType}.label`, {
      defaultValue: String(type),
    });
  }

  if (isWhitelabelContractType(numericType)) {
    return t(`contracts.whitelabelTypes.${numericType}.label`, {
      defaultValue: String(type),
    });
  }

  return String(type);
};

export const getCoreContractTypeOptions = (t) =>
  CONTRACT_TYPE_ORDER.map((type) => ({
    value: type,
    label: t(`contracts.types.${type}.label`),
    description: t(`contracts.types.${type}.description`),
  }));

export const getWhitelabelContractTypeOptions = (t) =>
  WHITELABEL_CONTRACT_TYPE_ORDER.map((type) => ({
    value: type,
    label: t(`contracts.whitelabelTypes.${type}.label`),
    description: t(`contracts.whitelabelTypes.${type}.description`),
  }));

export const getContractTypeOptions = (t, includeAll = false) => {
  const options = [
    ...getCoreContractTypeOptions(t),
    ...getWhitelabelContractTypeOptions(t),
  ];

  if (includeAll) {
    return [{ value: "", label: t("contracts.filters.allTypes") }, ...options];
  }

  return options;
};

export const getContractTypeOptionsForCompany = (t, companyCode) => {
  const normalizedCode = (companyCode || "").toLowerCase();
  if (normalizedCode === MOLE_COMPANY_CODE) {
    return getCoreContractTypeOptions(t);
  }
  return getWhitelabelContractTypeOptions(t);
};

export const isSignupVisibleContract = (contract) => {
  if (!contract) return false;
  if (isCoreContractType(contract.type)) return true;
  return isWhitelabelContractType(contract.type);
};
